export default __webpack_public_path__ + "static/media/ky.f7a068ed.svg";